module.exports = __webpack_public_path__ + "static/media/text_variation.ac0fc457.png";